import type { EntryPointOverlapKey } from "@/store/api/endpoints/adminV2EntryPointOverlapApi";

interface OverlapLabels {
  cohort: string;
  cards: readonly [string, string];
}

// CRITICAL: direct links describe the fixed server-owned pair, never labels
// supplied in a query string. See docs/admin/readmes/CRM_AND_SUPPORT.md.
const labels: Record<EntryPointOverlapKey, OverlapLabels> = {
  "health-did-not-connect--connected": {
    cohort: "Health check",
    cards: ["Didn't connect", "Connected"],
  },
  "health-did-not-generate--report-sent": {
    cohort: "Health check",
    cards: ["Didn't generate report", "Report generated"],
  },
  "health-not-opened-offer--saw-offer": {
    cohort: "Health check",
    cards: ["Didn't open the offer", "Saw trial offer"],
  },
  "health-did-not-start-checkout--left-checkout": {
    cohort: "Health check",
    cards: ["Didn't start checkout", "Left checkout"],
  },
  "health-not-opened-offer--trial-started": {
    cohort: "Health check",
    cards: ["Didn't open the offer", "Trial started"],
  },
  "health-did-not-start-checkout--trial-started": {
    cohort: "Health check",
    cards: ["Didn't start checkout", "Trial started"],
  },
  "health-left-checkout--trial-started": {
    cohort: "Health check",
    cards: ["Left checkout", "Trial started"],
  },
  "health-card-failed--did-not-continue": {
    cohort: "Health check",
    cards: ["Card failed", "Didn't continue"],
  },
  "trial-card-failed--did-not-continue": {
    cohort: "14-day trial (health check and trial signups)",
    cards: ["Card failed", "Didn't continue"],
  },
  "trial-signups-only-card-failed--did-not-continue": {
    cohort: "14-day trial signups only",
    cards: ["Card failed", "Didn't continue"],
  },
};

export const getEntryPointOverlapLabels = (key: EntryPointOverlapKey) =>
  labels[key];

export const getEntryPointOverlapTitle = (key: EntryPointOverlapKey) => {
  const [first, second] = labels[key].cards;
  return `In both: ${first} and ${second}`;
};
